import { Str } from "@workspace/core";

const {
  ASTERISK,
  capitalize,
  capitalizeStrict,
  COLON,
  COLON_WITH_SPACE,
  COMMA,
  COMMA_WITH_SPACE,
  COPYRIGHT,
  DASH,
  EMPTY,
  END_OF_LINE,
  EXCLAMATION_MARK,
  HASH,
  PERCENT,
  PERIOD,
  PERIOD_WITH_SPACE,
  QUESTION_MARK,
  SLASH,
  SPACE,
  UNDERSCORE,
  uppercase,
  VERTICAL_BAR,
  VERTICAL_BAR_WITH_SPACES,
} = Str;

type Asterisk = Str.Asterisk;
type CapitalizeStrict<T extends string> = Str.CapitalizeStrict<T>;
type Colon = Str.Colon;
type ColonWithSpace = Str.ColonWithSpace;
type Comma = Str.Comma;
type CommaWithSpace = Str.CommaWithSpace;
type Copyright = Str.Copyright;
type Dash = Str.Dash;
type Empty = Str.Empty;
type EndOfLine = Str.EndOfLine;
type ExclamationMark = Str.ExclamationMark;
type Hash = Str.Hash;
type Percent = Str.Percent;
type Period = Str.Period;
type PeriodWithSpace = Str.PeriodWithSpace;
type QuestionMark = Str.QuestionMark;
type Slash = Str.Slash;
type Space = Str.Space;
type Underscore = Str.Underscore;
type VerticalBar = Str.VerticalBar;
type VerticalBarWithSpaces = Str.VerticalBarWithSpaces;

export {
  ASTERISK,
  capitalize,
  capitalizeStrict,
  COLON,
  COLON_WITH_SPACE,
  COMMA,
  COMMA_WITH_SPACE,
  COPYRIGHT,
  DASH,
  EMPTY,
  END_OF_LINE,
  EXCLAMATION_MARK,
  HASH,
  PERCENT,
  PERIOD,
  PERIOD_WITH_SPACE,
  QUESTION_MARK,
  SLASH,
  SPACE,
  UNDERSCORE,
  uppercase,
  VERTICAL_BAR,
  VERTICAL_BAR_WITH_SPACES,
};
export type {
  Asterisk,
  CapitalizeStrict,
  Colon,
  ColonWithSpace,
  Comma,
  CommaWithSpace,
  Copyright,
  Dash,
  Empty,
  EndOfLine,
  ExclamationMark,
  Hash,
  Percent,
  Period,
  PeriodWithSpace,
  QuestionMark,
  Slash,
  Space,
  Underscore,
  VerticalBar,
  VerticalBarWithSpaces,
};
